export default "__VITE_ASSET__26909d3a__"